export default "__VITE_ASSET__AXvmoQul__"